import { SettlementReportSchema } from '@kilat/shared';
import { createRepo } from './_base.js';

/**
 * Sprint 120 — Settlement-statement cross-check reports.
 *
 *   platformBrands/{brandId}/settlementReports/{ts-…}
 *
 * Written by the `uploadSettlementCsv` super-admin callable; read access
 * scoped to super-admin of THIS brand per `infra/firestore.rules`.
 */
export function settlementReportsRepoFor(brandId: string) {
  return createRepo({
    path: `platformBrands/${brandId}/settlementReports`,
    schema: SettlementReportSchema,
    name: `platformBrands/${brandId}/settlementReports`,
  });
}
